module.exports = __webpack_public_path__ + "static/datenschutzerklarung-3e53c3ac86fbbc3a21bda14bfff2b9f5.pdf";